/**
 * Settings › Documents › Print Defaults (piece 27): the four margins a new
 * template is seeded with, each proposed at half an inch.
 *
 * 🔨 A margin outside nought to two inches is refused. Nought is a full-bleed
 * sheet no office printer can produce, and past two inches the ten regions no
 * longer fit the band the editor constrains them to.
 */
export const PRINT_MARGIN_TOP_KEY = 'print.marginTopInches';
export const PRINT_MARGIN_LEFT_KEY = 'print.marginLeftInches';
export const PRINT_MARGIN_RIGHT_KEY = 'print.marginRightInches';
export const PRINT_MARGIN_BOTTOM_KEY = 'print.marginBottomInches';

export const PRINT_MARGIN_DEFAULT_INCHES = 0.5;
export const PRINT_MARGIN_MIN_INCHES = 0;
export const PRINT_MARGIN_MAX_INCHES = 2;

export const PRINT_MARGIN_KEYS: readonly string[] = [PRINT_MARGIN_TOP_KEY, PRINT_MARGIN_LEFT_KEY, PRINT_MARGIN_RIGHT_KEY, PRINT_MARGIN_BOTTOM_KEY];

/** Piece 27's seeded rows: the four margins, each at half an inch. */
export const PIECE_27_SETTINGS: readonly { key: string; value: number }[] = PRINT_MARGIN_KEYS.map((key) => ({ key, value: PRINT_MARGIN_DEFAULT_INCHES }));

export function isPrintMarginKey(key: string): boolean {
  return PRINT_MARGIN_KEYS.includes(key);
}

/** The one sentence a refused margin carries, or null where the figure holds. */
export function printMarginProblem(value: unknown): string | null {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 'a margin is a number of inches';
  if (value < PRINT_MARGIN_MIN_INCHES || value > PRINT_MARGIN_MAX_INCHES) return `a margin is between ${PRINT_MARGIN_MIN_INCHES} and ${PRINT_MARGIN_MAX_INCHES} inches`;
  return null;
}
